// extracted by mini-css-extract-plugin
var _1 = "dark-mode";
var _2 = "f8eZdmua81C07Is0aIM0";
export { _1 as "dark-mode", _2 as "textarea" }
